import { Circle, Repeat, Send} from 'react-feather'

export default [
    {
        id: 'request2',
        title: 'Клуб',
        icon: <Send size={15} />,
        navLink: "request/club"
    },
    // {
    //     id: 'request',
    //     title: 'Хүсэлт',
    //     icon: <Send size={15} />,
    //     navLink: "/request",
    //     children: [
    //         {
    //             id: 'request1',
    //             title: 'Олон нийтийн ажил',
    //             icon: <Circle size={8} />,
    //             navLink: "request/volunteer"
    //         },
    //         {
    //             id: 'request3',
    //             title: 'Багшийн туслахаар ажиллах',
    //             icon: <Circle size={8} />,
    //             navLink: "request/tutor"
    //         },

    //     ]
    // }
]
